<template lang="pug">
  .shipment-selector
    .shipment-selector-step-1(v-if="!selected || !selectedShipment")
      .shipment-selector__title
        h3 Vui lòng chọn hình thức đặt hàng
      .shipment-selector__inner
        .shipment-selector-item(v-for="item in items" , :class="{'is-active' : selected === item.id}" @click="select(item.id,item.name)")
          .shipment-selector-item__content
            .shipment-selector-item__button
              .shipment-selector-item__icon
                component(:is="item.component")
              .shipment-selector-item__title {{ item.title }}
            .shipment-selector-item__description {{ item.description }}

    .shipment-selector-step-2(v-if="selectedShipment")
      .shipment-selector-step__inner(v-if="selectedShipment.name === 'delivery'")
        .shipment-selector-item__head
          .shipment-selector-item__head-icon
            component(:is="selectedShipment.component")
          .shipment-selector-item__head-title
            h3 {{ selectedShipment.title }}
            span {{ selectedShipment.description }}
        .shipment-selector-item__content
          p Vui lòng nhập địa chỉ giao hàng để được gợi ý cơ sở phù hợp nhất.

          .shipment-selector-item__address-box
            IconMarker()
            gmap-autocomplete(ref="mapRef", @place_changed="changeAddress", placeholder="Địa chỉ giao hàng", :options="options" v-show="!loading")
          .shipment-selector-item__restaurants(v-if="showRestaurantList")
            p.hint Cơ sở gần nhất
            .shipment-selector-item__poslist
              perfect-scrollbar()
                PosList(:posData.sync="posList" , :location.sync="location" , type="DELI")

      .shipment-selector-step__inner(v-else-if="selectedShipment.name === 'pickup'")
        .shipment-selector-item__head
          .shipment-selector-item__head-icon
            component(:is="selectedShipment.component")
          .shipment-selector-item__head-title
            h3 {{ selectedShipment.title }}
            span {{ selectedShipment.description }}
        .shipment-selector-item__content
          p Chọn cơ sở đặt và nhận hàng phù hợp với bạn
          .shipment-selector-item__poslist(:class="selectedShipment.name")
            perfect-scrollbar()
              PosList(:posData.sync="posList" , :location.sync="location" , type="PICK")
</template>
<script>
  import {mapState} from 'vuex'
  import IconMarker from "./icons/IconMarker";
  import PosList from "./PosList";

  import IconDelivery64 from './icons/IconDelivery64';
  import IconPickup64 from './icons/IconPickup64';
  export default {
    name: 'ShipmentSelector',
    components: {
      PosList,
      IconMarker,
      IconDelivery64,
      IconPickup64,
    },
    data () {
      return {
        loading: true,
        options: {
          componentRestrictions:{
            country:['vn']
          },
          strictBounds:true
        },
        showRestaurantList : false,
      }
    },
    computed: {
      ...mapState({
        selected: state => state.shipments.selected,
        selectedShipment: state => state.shipments.selectedShipment, // lấy đối tượng
        items: state => state.shipments.all,
        restaurants: state => state.restaurants.all,
        location: state => state.shipments.location,
      }),
      posList () {
        return this.restaurants.map(item => item.pos)
      },
    },
    created() {
      //this.$store.dispatch('shipments/setSelected', null)
      let bd = document.getElementsByTagName("body")[0];
      bd.classList.add('has-overlay');
      this.$store.dispatch('shipments/resetState', null)

    },
    mounted () {
      this.loading = false
    },
    updated() {
    },
    destroyed() {
      let bd = document.getElementsByTagName("body")[0];
      bd.classList.remove('has-overlay');
    },
    methods: {
      select (id, type = 'delivery') {
        this.$store.dispatch('shipments/setSelected', id)
        if ('pickup' === type) {
          this.getUserLocation();
        }
      },
      changeAddress (place) {
        if (place.geometry) {
          this.$store.dispatch('shipments/setDeliveryAddress', place)
          let  loc = {
            lng: place.geometry.location.lng(),
            lat: place.geometry.location.lat(),
            address: place.formatted_address,
          }
          this.$store.dispatch('shipments/setLocation', loc)

          this.showRestaurantList = true
        }
      },
      getRestaurantList() {

      },
      async getUserLocation() {
        let loc = await this.$getLocation().then(({lat, lng}) => ({ lat, lng}));
        if (loc) {
          this.$store.dispatch('shipments/setLocation', loc)
          this.showRestaurantList = true
        }

      }
    }
  }
</script>
<style>
  .pac-target-input {
    border: none!important;
    outline: none!important;
  }
</style>



// WEBPACK FOOTER //
// src/components/ShipmentSelector.vue